import { Directive, Inject, Input } from "@angular/core";
import { GenericActions } from "../../redux/generic-actions";
import { ImmutableRedux } from "../../redux/immutable-redux.service";
import { TOGGLE_DISPLAY_STATE_PROP } from "./state-props";

@Directive({
    selector: "[common-toggle-display-action-creators]",
    exportAs: "ToggleActions",
})
export class CommonToggleDisplayActionsDirective {
    @Input() public stateProp: string;

    constructor(
        private ngRedux: ImmutableRedux<any>,
        @Inject(TOGGLE_DISPLAY_STATE_PROP) public rootProp,
    ) { }

    public toggle(index) {
        const payload = index;
        this.ngRedux.dispatchFactory(GenericActions.DISPLAY_TOGGLED, this.rootProp, this.stateProp, payload);
    }

    public reset() {
        this.ngRedux.dispatchFactory(GenericActions.STATE_RESET, this.rootProp, this.stateProp);
    }
}
